import { Popover, PopoverContent, PopoverTrigger } from "@radix-ui/react-popover"
import { observer } from "mobx-react-lite"

import { LcAddress } from "@/domains/core"
import { cn, shortestValue } from "@/domains/library"

export type IMinimumPoolInputGaugeBalance = {
  address: LcAddress
  decimals: number
  onChainUserGaugeBalance: bigint
  formatUnits: (wei: bigint) => string
}

export const MinimalPoolInputGaugeBalance = observer(
  ({
    pool,
    label,
    minDecimals = 3,
    className,
  }: {
    pool: IMinimumPoolInputGaugeBalance | null | undefined
    label: React.ReactNode
    minDecimals?: number
    className?: string
  }) => {
    if (!pool) {
      return null
    }

    return (
      <Popover>
        <PopoverTrigger asChild>
          <span className={cn("flex items-center gap-1 text-sm", className)}>
            {label}{" "}
            {pool && pool.onChainUserGaugeBalance
              ? shortestValue({
                  value: pool.formatUnits(pool.onChainUserGaugeBalance),
                  decimals: pool.decimals,
                  minDecimals,
                })
              : "0.00"}
          </span>
        </PopoverTrigger>
        <PopoverContent className="w-120">{pool.formatUnits(pool.onChainUserGaugeBalance)}</PopoverContent>
      </Popover>
    )
  },
)
